import { render, staticRenderFns } from "./PptUpload.vue?vue&type=template&id=b1a1685e&scoped=true"
import script from "./PptUpload.vue?vue&type=script&lang=ts"
export * from "./PptUpload.vue?vue&type=script&lang=ts"
import style0 from "./PptUpload.vue?vue&type=style&index=0&id=b1a1685e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a1685e",
  null
  
)

export default component.exports